import '../index.css';
var styles = {
  "textReset": "bp_text_module_textReset--353d5",
  "breakWord": "bp_text_module_breakWord--353d5",
  "textOnLightDefault": "bp_text_module_textOnLightDefault--353d5",
  "textOnLightSecondary": "bp_text_module_textOnLightSecondary--353d5",
  "textOnLightLink": "bp_text_module_textOnLightLink--353d5",
  "textOnDarkDefault": "bp_text_module_textOnDarkDefault--353d5",
  "titleMondo": "bp_text_module_titleMondo--353d5",
  "titleXLarge": "bp_text_module_titleXLarge--353d5",
  "titleLarge": "bp_text_module_titleLarge--353d5",
  "titleMedium": "bp_text_module_titleMedium--353d5",
  "titleSmall": "bp_text_module_titleSmall--353d5",
  "subtitle": "bp_text_module_subtitle--353d5",
  "bodyLargeBold": "bp_text_module_bodyLargeBold--353d5",
  "bodyLarge": "bp_text_module_bodyLarge--353d5",
  "bodyDefaultBold": "bp_text_module_bodyDefaultBold--353d5",
  "bodyDefaultSemibold": "bp_text_module_bodyDefaultSemibold--353d5",
  "bodyDefault": "bp_text_module_bodyDefault--353d5",
  "caption": "bp_text_module_caption--353d5",
  "labelBold": "bp_text_module_labelBold--353d5",
  "label": "bp_text_module_label--353d5"
};
export { styles as default };